module.exports = __webpack_public_path__ + "packs/media/images/Profile_Active-60d49ba4e96f9b7daa25e50144f2e53b.svg";